css rect fill:currentColor
css svg h:100% w:auto

tag app-logo
	<self>
		<svg[va:top] width="108" height="72" viewBox="0 0 108 72" fill="none" xmlns="http://www.w3.org/2000/svg">
			<rect x="48" width="60" height="20" rx="10">
			<rect x="25" y="52" width="60" height="20" rx="10">
			<rect x="49" y="26" width="36" height="20" rx="10">
			<rect y="52" width="20" height="20" rx="10">